export default __webpack_public_path__ + "static/media/OTP.0845d644.svg";